import React, {useEffect, useState} from 'react';
import {FormControl} from "@mui/material";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import {LoadingHelper} from "../../util/LoadingHelper";

import {dataURLtoFile} from "../../util/converBase64ToImage";
import {css} from "@emotion/css";
import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer, RaikoCreatorInfo,
    RaikoDivider,
    RaikoGridOneColumn,
    RaikoGridTwoColumn, RaikoImageCropper,
    RaikoMaterialOutlinedInput, RaikoMobileInputOutlined,
    RaikoNumberInputOutlined,
    RaikoSectionContainer,
    showErrorMessage,
    showSuccessMessage,
    showWarningMessage
} from "@moeindal/base-raiko-panel-components";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";

import defaultAvatar from "../../assets/images/avatar-default.jpg"


const UserProfileDetailPage = (
    {
        profileDetail,
        setProfileDetail,
        avatarFile,
        setAvatarFile,
        service,
        adminId = -1,
        avatarLoadingState = false
    }) => {


    const loadingDispatcher = useLoadingDispatcher()
    const loading = new LoadingHelper(loadingDispatcher)

    useEffect(() => {
        if (profileDetail && profileDetail.firstName) {
            setProfileDataToFields();
        }
    }, [profileDetail])

    function setProfileDataToFields() {
        setFirstName(profileDetail.firstName)
        setLastName(profileDetail.lastName)
        setNationalCode(profileDetail.nationalCode)
        setUserName(profileDetail.username)
        setPhoneNumber(profileDetail.phoneNumber)
        setCreatedBy(profileDetail.createdBy)
        setCreatedAt(convertUniversalDateTimeToPersianDateTime(profileDetail.createdAt))
    }

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [nationalCode, setNationalCode] = useState("");
    const [userName, setUserName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");

    const [imageFile, setImageFile] = useState(null);
    const [imageId, setImageId] = useState(-1);
    const [image, setImage] = useState(null)

    const [avatarLoading, setAvatarLoading] = useState(avatarLoadingState)

    const [createdBy, setCreatedBy] = useState("");
    const [createdAt, setCreatedAt] = useState("");



    const onImageChange = (event) => {
        if (event.target.files && event.target.files[0]) {
            setImageFile(event.target.files[0]);
            setImageId(-1)
            setImage(URL.createObjectURL(event.target.files[0]));
        }
    }

    function eraseImage() {
        setImageFile(null)
        setImage(null)
        setImageId(-1)
    }

    function checkFields() {
        let message = ""
        let state = false

        if (firstName.length === 0)
            message = "لطفا نام ادمین را وارد نمایید!"
        else if (lastName.length === 0)
            message = "لطفا نام خانوادگی ادمین را وارد نمایید!"
        else if (nationalCode.length < 8)
            message = "خطا، لطفا کد ملی مدیر را به درستی وارد نمایید!"
        else if (phoneNumber.length !== 11)
            message = "لطفا شماره همراه ادمین را به درستی وارد نمایید!"
        else
            state = true

        showWarningMessage(message)

        return state
    }

    function handleUpdateDetail() {
        if (checkFields()) {
            if (adminId >= 0) {
                updateManagerInfo()
            } else {
                updateAdminInfo()
            }
        }
    }

    function updateManagerInfo() {
        loading.show()
        service.updateProfileDetailById(
            adminId,
            {
                "firstName": firstName,
                "lastName": lastName,
                "nationalCode": nationalCode,
                "phoneNumber": phoneNumber
            }).then(response => {
            setProfileDetail(response)
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            loading.hide()
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
            loading.hide()
        })
    }

    function updateAdminInfo() {
        loading.show()
        service.updateProfileInfo({
            "firstName": firstName,
            "lastName": lastName,
            "nationalCode": nationalCode,
            "phoneNumber": phoneNumber
        }).then(response => {
            setProfileDetail(response)
            showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            loading.hide()
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
            loading.hide()
        })
    }


    const updateAvatar = (imgSrc, fileName) => {
        loading.show()
        const imageFile = dataURLtoFile(imgSrc, fileName)

        service.updateAdminAvatar(imageFile, adminId)
            .then(response => {
                setAvatarFile(response.downloadUrl)
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
                loading.hide()
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
            loading.hide()
        })
    }

    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer className={css`margin-top: 1rem`}>
                <RaikoSectionContainer
                    title={"حساب کاربری"}
                    hasActionButton
                    actionButtonOnclick={handleUpdateDetail}
                >
                    <RaikoGridOneColumn>
                        <RaikoImageCropper
                            avatarFile={avatarFile}
                            updateAvatar={updateAvatar}
                            loading={avatarLoading}
                        defaultThumbnail={defaultAvatar}
                        />
                        <RaikoDivider/>
                        <RaikoGridTwoColumn>
                            <FormControl fullWidth>
                                <RaikoMaterialOutlinedInput
                                    labelText={"نام"}
                                    value={firstName}
                                    setValue={setFirstName}
                                />
                            </FormControl>

                            <FormControl fullWidth>
                                <RaikoMaterialOutlinedInput
                                    labelText={"نام خانوادگی"}
                                    value={lastName}
                                    setValue={setLastName}
                                />
                            </FormControl>
                            <FormControl>
                                <RaikoNumberInputOutlined
                                    maxLength={"10"}
                                    value={nationalCode}
                                    setValue={setNationalCode}
                                    labelText={"کد ملی"}
                                />
                            </FormControl>

                            <FormControl fullWidth>
                                <RaikoMobileInputOutlined
                                    placeHolder={"091..."}
                                    labelText={"شماره همراه"}
                                    value={phoneNumber}
                                    setValue={setPhoneNumber}
                                />
                            </FormControl>

                            <FormControl fullWidth>
                                <RaikoMaterialOutlinedInput
                                    labelText={"نام کاربری"}
                                    value={userName}
                                    disabled
                                    setValue={setUserName}
                                />
                            </FormControl>

                        </RaikoGridTwoColumn>
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>
            <RaikoCreatorInfo createdBy={createdBy} createdAt={createdAt}/>
        </RaikoGridOneColumn>

    )
}

export default UserProfileDetailPage;
